




import { defineComponent } from '@vue/composition-api';
import TtamTipBox from '@/components/common/tip-box/index.vue';

const name = 'ttam-promotion-pixel-mid-funnel-tips';

export default defineComponent({
  name,
  components: { TtamTipBox },
  setup() {
    return {
      name,
    };
  },
});
